import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerAttendance() {
  const { baseurl, token, setIsUnauthorised, AdminId } =
    useGlobalContext();

  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH VOLUNTEER ATTENDANCE ---------------- */

  const fetchVolunteerAttendance = useCallback(
    async ({
      volunteerCode = "",
      fromDate = "",
      toDate = "",
    } = {}) => {
      setLoading(true);

      try {
        const res = await axios.post(
          `${baseurl}/api/VolunteerAdmin/v1.0/getVolunteerAttendanceRecord`,
          {
            adminId: AdminId,
            volunteerCode,
            fromDate,
            toDate,
          },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

        if (res.data.responseCode === "00") {
  const raw = res.data.data || [];

const formatted = raw.map((v) => {
  const attendanceMap = {};

  (v.attendance || []).forEach((a) => {
    if (a.date) {
      attendanceMap[a.date] = a.status;
    }
  });

  return {
    volunteerCode: v.volunteerCode || v.volunteer_code, // 🔥 normalize here
    name: v.name,
    type: v.type,
    attendanceMap,
  };
});

  setAttendanceData(formatted);
  return formatted;
}


        if (res.data.responseCode === "401") {
          setIsUnauthorised(true);
        } else {
          toast.error(res.data.responseMessage);
        }

        return [];
      } catch (error) {
        toast.error("Error fetching attendance record");
        return [];
      } finally {
        setLoading(false);
      }
    },
    [baseurl, token, AdminId, setIsUnauthorised]
  );

  /* ---------------- UPDATE VOLUNTEER ATTENDANCE ---------------- */

const updateVolunteerAttendance = useCallback(
  async (dataArray = []) => {
    if (!dataArray.length) {
      toast.message("No changes to update");
      return false;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${baseurl}/api/VolunteerAdmin/v1.0/updateVolunteerAttendanceRecord`,
        {
          adminId: AdminId,
          data: dataArray,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res.data.responseCode === "00") {
        toast.success("Attendance Updated Successfully");
        return true;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }

      return false;
    } catch (error) {
      toast.error("Error updating attendance");
      return false;
    } finally {
      setLoading(false);
    }
  },
  [baseurl, token, AdminId, setIsUnauthorised]
);

  return {
    attendanceData,
    loading,
    fetchVolunteerAttendance,
    updateVolunteerAttendance,
  };
}
